import { render } from "./FunRunRegistrationView.vue?vue&type=template&id=36f1145f"
import script from "./FunRunRegistrationView.vue?vue&type=script&lang=js"
export * from "./FunRunRegistrationView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__